import { Dimensions } from '~/lib/api/smartsend/types';

export function DimensionsAreValid(dimensions: Dimensions, dimensionsRequired: boolean) {
  return (
    dimensions.Weight > 0 &&
    (!dimensionsRequired || (dimensions.Height > 0 && dimensions.Length > 0 && dimensions.Width > 0))
  );
}
